import { LayersControl, TileLayer } from 'react-leaflet'

interface BaseLayerProps {
  name: string
  url: string
  checked?: boolean
  maxNativeZoom?: number
  maxZoom?: number
  subdomains?: string[]
  attribution?: string
}

const EMPTY_ARRAY: string[] = []

const BaseLayer: React.FC<BaseLayerProps> = ({
  name,
  url,
  checked = false,
  maxNativeZoom = 19,
  maxZoom = 22,
  subdomains = EMPTY_ARRAY,
  attribution,
}) => {
  return (
    <LayersControl.BaseLayer checked={checked} name={name}>
      <TileLayer
        attribution={attribution}
        maxNativeZoom={maxNativeZoom}
        maxZoom={maxZoom}
        subdomains={subdomains}
        url={url}
      />
    </LayersControl.BaseLayer>
  )
}

interface BaseLayersProps {
  children?: React.ReactNode
}

export const BaseLayers: React.FC<BaseLayersProps> & {
  Layer: React.FC<BaseLayerProps>
} = ({ children }) => {
  if (children) {
    return <>{children}</>
  }

  // Default base layers
  return (
    <>
      <BaseLayer
        checked
        name="Híbrido"
        subdomains={['mt0', 'mt1', 'mt2', 'mt3']}
        url="http://{s}.google.com/vt/lyrs=y&x={x}&y={y}&z={z}"
      />
      <BaseLayer
        name="Satélite"
        subdomains={['mt0', 'mt1', 'mt2', 'mt3']}
        url="http://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}"
      />
      <BaseLayer
        name="Elevación"
        subdomains={['mt0', 'mt1', 'mt2', 'mt3']}
        url="http://{s}.google.com/vt/lyrs=p&x={x}&y={y}&z={z}"
      />
      <BaseLayer
        name="OSM"
        subdomains={['a', 'b', 'c']}
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      <BaseLayer
        name="Mapbox Satellite"
        url="https://api.mapbox.com/styles/v1/mapbox/satellite-v9/tiles/256/{z}/{x}/{y}?access_token=pk.eyJ1IjoicnV1dHMtbGEiLCJhIjoiY2xjdGR2a3ZqMHBocDN2cHNmbHN2am9nbSJ9.O-_YjVHUBZboonboQd19zA"
      />
    </>
  )
}

BaseLayers.Layer = BaseLayer
